import React, { useEffect, Fragment, useState } from "react";
import Breadcrumb from "../../../components/common/breadcrumb";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import DataTable from "react-data-table-component";
import { CSVLink } from "react-csv";
import { showToast } from "../../../components/ToastifyNotification";
import { UncontrolledTooltip } from "reactstrap";
import Swal from "sweetalert2";
import { DeleteLedgerAccount, GetLedgerAccounts } from "../../../api/masters/ledgerAccountAPI";

const ListLedgerAccount = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const fetchStates = async data => {
    dispatch({ type: "LOADER_START" });
    try {
      const response = await GetLedgerAccounts(data); // Make sure login function returns token
      
      if (response.success) {
        showToast("success", response.message);
        const formattedData = response.data.map((item, index) => ({
          index: index + 1,
          id: item._id,
          name: item.name,
          shortName: item.shortName,
          underGroup: item.underGroup,
          tdsName: item.tdsName,
          depreciationPercentage1: item.depreciationPercentage1,
          depreciationPercentage2: item.depreciationPercentage2,
          nature: item.nature,
          openingBalance: item.openingBalance,
          contactPerson: item.contactPerson,
          address: item.address,
          city: item.cityId?.name || "",
          area: item.areaId?.name || "",
          phoneNo: item.phoneNo,
          mobileNo: item.mobileNo,
          fax: item.fax,
          email: item.email,
          creditLimit: item.creditLimit,
          creditDays: item.creditDays,
          gstinNo: item.gstinNo,
          clientNature: item.clientNature,
          cstNo: item.cstNo,
          lstNo: item.lstNo,
          panNo: item.panNo,
          tinNo: item.tinNo,
          itWardNo: item.itWardNo,
          drugLicenseNo: item.drugLicenseNo,
          remark: item.remark,
          bank: item.bank,
          bankAddress: item.bankAddress,
          ifscCode: item.ifscCode,
          accountNo: item.accountNo,
          active: item.active
        }));
        setData(formattedData);
        setFilteredData(formattedData);
      } else {
        // setError(response.message);
        showToast("error", response.message);
      }
    } catch (error) {
      // setError(error); // Handle login errors
      showToast("error", error);
    } finally {
      dispatch({ type: "LOADER_STOP" });
    }
  };

  useEffect(() => {
    fetchStates();
  }, []);

  useEffect(
    () => {
      const results = data.filter(item =>
      Object.values(item)
        .join(" ")
        .toLowerCase()
        .includes(search.toLowerCase())
    );
    setFilteredData(results);
    },
    [search, data]
  );

  const handleEditClick = Id => {
    navigate(`/masters/ledger-account/edit/${Id}`);
  };

  const handleDeleteClick = async id => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!"
    }).then(async result => {
      if (result.isConfirmed) {
        dispatch({ type: "LOADER_START" });
        try {
          const response = await DeleteLedgerAccount(id);
          if (response.success) {
            showToast("success", response.message);
            setData(data.filter(item => item.id !== id));
            setFilteredData(filteredData.filter(item => item.id !== id));
          } else {
            showToast("error", response.message);
          }
        } catch (error) {
          console.error("Error deleting ledger account:", error);
          showToast("error", error);
        } finally {
          dispatch({ type: "LOADER_STOP" });
        }
      }
    });
  };

  const columns = [
  {
    name: "S.No",
    selector: (row) => row.index,
    sortable: true,
    width: "5%",
  },
  {
    name: "Name",
    selector: (row) => row.name,
    sortable: true,
    width: "8%",
  },
  {
    name: "Short Name",
    selector: (row) => row.shortName,
    sortable: true,
    width: "8%",
  },
  {
    name: "Under Group",
    selector: (row) => row.underGroup,
    sortable: true,
    width: "8%",
  },
  {
    name: "TDS Name",
    selector: (row) => row.tdsName,
    sortable: true,
    width: "8%",
  },
  {
    name: "Depreciation %1",
    selector: (row) => row.depreciationPercentage1,
    sortable: true,
    width: "8%",
  },
  {
    name: "Depreciation %2",
    selector: (row) => row.depreciationPercentage2,
    sortable: true,
    width: "8%",
  },
  {
    name: "Nature",
    selector: (row) => row.nature,
    sortable: true,
    width: "8%",
  },
  {
    name: "Opening Balance",
    selector: (row) => row.openingBalance,
    sortable: true,
    width: "8%",
  },
  {
    name: "Contact Person",
    selector: (row) => row.contactPerson,
    sortable: true,
    width: "8%",
  },
  {
    name: "Address",
    selector: (row) => row.address,
    sortable: true,
    width: "8%",
  },
  {
    name: "City",
    selector: (row) => row.city,
    sortable: true,
    width: "8%",
  },
  {
    name: "Area",
    selector: (row) => row.area,
    sortable: true,
    width: "8%",
  },
  {
    name: "Phone No",
    selector: (row) => row.phoneNo,
    sortable: true,
    width: "8%",
  },
  {
    name: "Mobile No",
    selector: (row) => row.mobileNo,
    sortable: true,
    width: "8%",
  },
  {
    name: "Fax",
    selector: (row) => row.fax,
    sortable: true,
    width: "8%",
  },
  {
    name: "Email",
    selector: (row) => row.email,
    sortable: true,
    width: "8%",
  },
  {
    name: "Credit Limit",
    selector: (row) => row.creditLimit,
    sortable: true,
    width: "8%",
  },
  {
    name: "Credit Days",
    selector: (row) => row.creditDays,
    sortable: true,
    width: "8%",
  },
  {
    name: "GSTIN No",
    selector: (row) => row.gstinNo,
    sortable: true,
    width: "8%",
  },
  {
    name: "Client Nature",
    selector: (row) => row.clientNature,
    sortable: true,
    width: "8%",
  },
  {
    name: "CST No",
    selector: (row) => row.cstNo,
    sortable: true,
    width: "8%",
  },
  {
    name: "LST No",
    selector: (row) => row.lstNo,
    sortable: true,
    width: "8%",
  },
  {
    name: "PAN No",
    selector: (row) => row.panNo,
    sortable: true,
    width: "8%",
  },
  {
    name: "TIN No",
    selector: (row) => row.tinNo,
    sortable: true,
    width: "8%",
  },
  {
    name: "IT Ward No",
    selector: (row) => row.itWardNo,
    sortable: true,
    width: "8%",
  },
  {
    name: "Drug License No",
    selector: (row) => row.drugLicenseNo,
    sortable: true,
    width: "8%",
  },
  {
    name: "Remark",
    selector: (row) => row.remark,
    sortable: true,
    width: "8%",
  },
  {
    name: "Bank",
    selector: (row) => row.bank,
    sortable: true,
    width: "8%",
  },
  {
    name: "Bank Address",
    selector: (row) => row.bankAddress,
    sortable: true,
    width: "8%",
  },
  {
    name: "IFSC Code",
    selector: (row) => row.ifscCode,
    sortable: true,
    width: "8%",
  },
  {
    name: "Account No",
    selector: (row) => row.accountNo,
    sortable: true,
    width: "8%",
  },
  {
    name: "Active",
    selector: (row) => (row.active ? "Yes" : "No"),
    sortable: true,
    center: true,
    width: "10%",
  },
  {
    name: "Actions",
    cell: (row) => (
      <div>
        <button
          className="btn btn-primary me-2"
          onClick={() => handleEditClick(row.id)}
          id={`edit-${row.id}`}
        >
          <i className="fa fa-pencil-square-o" />
        </button>
        <UncontrolledTooltip placement="top" target={`edit-${row.id}`}>
          Edit
        </UncontrolledTooltip>

        <button
          className="btn btn-danger"
          onClick={() => handleDeleteClick(row.id)}
          id={`delete-${row.id}`}
        >
          <i className="fa fa-trash-o" />
        </button>
        <UncontrolledTooltip placement="top" target={`delete-${row.id}`}>
          Delete
        </UncontrolledTooltip>
      </div>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
    width: "10%",
  },
];

  const headers = [
    { label: "S.No", key: "index" },
    { label: "Ledger Name", key: "ledgerName" },
    { label: "Opening Balance", key: "openingBalance" },
    { label: "Contact Person", key: "contactPerson" },
    { label: "Address", key: "address" },
    { label: "City", key: "city" },
    { label: "Area", key: "area" },
    { label: "Phone No", key: "phoneNo" },
    { label: "Mobile No", key: "mobileNo" },
    { label: "Fax", key: "fax" },
    { label: "Email", key: "email" },
    { label: "Credit Limit", key: "creditLimit" },
    { label: "Credit Days", key: "creditDays" },
    { label: "GSTIN No", key: "gstinNo" },
    { label: "Client Nature", key: "clientNature" },
    { label: "CST No", key: "cstNo" },
    { label: "LST No", key: "lstNo" },
    { label: "PAN No", key: "panNo" },
    { label: "TIN No", key: "tinNo" },
    { label: "IT Ward No", key: "itWardNo" },
    { label: "Drug License No", key: "drugLicenseNo" },
    { label: "Remark", key: "remark" },
    { label: "Bank", key: "bank" },
    { label: "Bank Address", key: "bankAddress" },
    { label: "IFSC Code", key: "ifscCode" },
    { label: "Account No", key: "accountNo" },
    { label: "Active", key: "active" },
  ];

  const ExportCSV = ({ data }) =>
    <CSVLink data={data} headers={headers} filename="ledgers.csv">
      <button
        className="btn btn-primary"
        id="export"
        style={{ marginTop: "5px" }}
      >
        Export
      </button>
      <UncontrolledTooltip placement="top" target="export">
        Export to CSV
      </UncontrolledTooltip>
    </CSVLink>;

  return (
    <Fragment>
      <Breadcrumb parent="Ledger Account" title="List Ledger Account" />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <h5>Ledger Account</h5>
                  <Link to={`/masters/ledger-account/add`}>
                    <button className="btn btn-primary" id="create">
                      Create Ledger Account
                    </button>
                    <UncontrolledTooltip placement="top" target="create">
                      Create Ledger Account
                    </UncontrolledTooltip>
                  </Link>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Search ledger account..."
                      value={search}
                      onChange={e => setSearch(e.target.value)}
                      style={{ marginTop: "5px" }}
                    />
                  </div>
                  <div className="col-sm-6 text-end">
                    <ExportCSV data={data} />
                  </div>
                </div>
              </div>
              <div className="card-body">
                  <DataTable
                    columns={columns}
                    data={filteredData}
                    pagination
                    highlightOnHover
                  />{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ListLedgerAccount;
